var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundWavesLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 461,
    viewBox: "0 0 210 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210 461L112.812 460.758C112.812 460.758 110.78 451.319 110.056 445.948C97.7507 354.562 112.536 233.69 148.367 142.417C188.686 39.7091 210 0.146057 210 0.146057L210 461Z",
    fill: "#00BFB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210 461L1.58075 461C1.58075 461 8.00664 350.949 93.6597 254.056C150.932 189.268 210 107.064 210 107.064L210 461Z",
    fill: "#C42EA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210 461L36.3173 461C36.3173 461 43.4433 375.056 118.266 250.956C157.348 186.134 210 68.3524 210 68.3524L210 461Z",
    fill: "url(#paint0_linear_5490_29792)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5490_29792",
    x1: 565.581,
    y1: 461.068,
    x2: 66.825,
    y2: 583.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025F83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWavesLight);
export default __webpack_public_path__ + "static/media/backgroundWaves-light.82f3adbf938c0b4075e37015f363ebb4.svg";
export { ForwardRef as ReactComponent };